<div class="body">
    <mat-toolbar>
        <button mat-icon-button>
            <mat-icon>shopping_cart</mat-icon>
        </button>
        <span>Warenkorb</span>
        <span class="spacer"></span>
        <button mat-icon-button (click)="close()">
            <mat-icon>clear</mat-icon>
        </button>
    </mat-toolbar>
    <div class="content">
        <div class="preview-content preview-entry-container">
            <div *ngFor="let product of products" class="preview-entry">
                
                <button mat-icon-button class="control-button delete" (click)="removeItem(product)">
                    <mat-icon class="icon">delete_forever</mat-icon>
                </button>
            </div>
        </div>
        <div class="summary-content">
            <div class="text">
                Dieser Warenkorb enthält {{products.length}} Produkte.
            </div>
            <table class="mat-table product-table striped-table">
                <tbody>
                    <tr class="mat-row row body-row">
                        <td class="mat-cell">Einrichtung gesamt</td>
                        <td class="mat-cell">
                            {{ setupPriceSum | number:'.2' }}
                        </td>
                    </tr>
                    <tr class="mat-row row body-row">
                        <td class="mat-cell">Kauf gesamt</td>
                        <td class="mat-cell">
                            {{ purchasePriceSum | number:'.2' }}
                        </td>
                    </tr>
                    <tr class="mat-row row body-row">
                        <td class="mat-cell">Miete gesamt</td>
                        <td class="mat-cell">
                            {{ rentalPriceSum | number:'.2' }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="footer">
        <button *ngIf="products.length > 0" mat-raised-button class="footer-button" color="primary" (click)="confirmOrder()">
            Warenkorb buchen
        </button>
        <button *ngIf="products.length == 0" mat-raised-button class="footer-button" color="warn" (click)="close()">
            Schließen
        </button>
    </div>
</div>